// @flow

export const EVENT_SENDERS = {
  CHATBOT: 'chatbot',
  WIZARD: 'wizard'
}

export type EventSenderType = $Values<typeof EVENT_SENDERS>
